import React from 'react';
import styles from './O_TimeCounter.module.css';
import cn from 'classnames';
import {
  useTimeCounter,
  UseTimeCounterParams,
  timeBounds,
} from '@/hooks/useTimeCounter';
import M_WheelColumn from '@/components/M_Molecules/M_WheelColumn/M_WheelColumn';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface O_TimeCounterProps extends UseTimeCounterParams {
  className?: string;
  maxWidth?: string | number;
  visibleSlots?: 3 | 5;
}

export default function O_TimeCounter({
  className,
  maxWidth = '320px',
  visibleSlots,
  ...params
}: O_TimeCounterProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const increaseText = t('common.timeCounter.increase');
  const decreaseText = t('common.timeCounter.decrease');
  const { value, inc, dec, columns } = useTimeCounter(params);
  const columnsCount = columns.length || 1;

  return (
    <div className={cn(styles.wrapper, className)}>
      <div
        className={styles.columns}
        style={{
          gridTemplateColumns: `repeat(${columnsCount}, 1fr)`,
          maxWidth,
        }}
      >
        {columns.map(({ unit }) => {
          const label = t(`common.timeUnits.${unit}`);

          return (
            <div key={unit} className={styles.column}>
              <M_WheelColumn
                value={value[unit]}
                min={timeBounds[unit].min}
                max={timeBounds[unit].max}
                visibleSlots={visibleSlots}
              />
              <button
                type='button'
                className={styles.arrow}
                aria-label={`${increaseText} ${label}`}
                onClick={() => inc(unit)}
              >
                <Q_Icon.ArrowUpIcon width={16} height={16} fill='none' />
              </button>
              <button
                type='button'
                className={cn(styles.arrow, styles.down)}
                aria-label={`${decreaseText} ${label}`}
                onClick={() => dec(unit)}
              >
                <Q_Icon.ArrowDownIcon width={16} height={16} fill='none' />
              </button>
              <span className={cn(styles.label, 'text-caption')}>{label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
